


































import Segment from '@/components/estimates/common/segments/Segment';
import AttachmentTypeControl from '@/components/estimates/expertEstimate/AttachmentTypeControl.vue';
import {Attachment, AttachmentType, ExpertEstimateState as EstimateState} from '@/model/api';
import {Estimate} from '@/model/Estimate';
import {right} from 'fp-ts/lib/Either';
import {Component, Inject, Prop} from 'vue-property-decorator';
import VueScrollTo from 'vue-scrollto';
import draggable from 'vuedraggable';

@Component({components: {draggable, AttachmentTypeControl}})
export default class AttachmentsSegment<T extends EstimateState> extends Segment<T> {
    @Inject()
    public readonly model: Estimate<T>;

    @Prop({type: Array, required: true})
    public readonly availableAttachmentTypes: AttachmentType[];

    @Prop({type: Array, required: true})
    public readonly enabledAttachmentTypes: AttachmentType[];

    @Prop({type: Array, required: true})
    public readonly attachments: Attachment[];

    @Prop({type: Object, required: true})
    public readonly estimate: T;

    private estimateState = this.estimate;

    private enabledAttachments = this.estimate.enabledAttachmentTypes;

    private disabledAttachments = this.availableAttachmentTypes.filter(
        type => ! this.enabledAttachments.includes(type),
    );

    public async submit() {
        return right(this.estimateState);
    }

    public hasNotSubmittedChanges(): boolean {
        return false; // this segment does not use submit button
    }

    public clearNotSubmittedChanges(): void {
    }

    public allowsMovingOn(): boolean {
        return true;
    }

    public onDragEnd(event: { newIndex: number }): void {
        if (this.model.changeAttachmentPosition === undefined) {
            throw new Error('Estimate does not support attachment position change');
        }

        const position = event.newIndex;
        const attachmentType = this.enabledAttachments[position];

        this.model.changeAttachmentPosition(attachmentType, position)
            .then(() => this.refresh());
    }

    private attachmentsByType(type: AttachmentType): Attachment[] {
        return this.attachments.filter(attachment => attachment.type === type);
    }

    private scrollToAttachment(attachmentType: AttachmentType): void {
        this.$nextTick(() => {
            const element = document.getElementById('attachment-type-' + attachmentType);
            if (element) {
                VueScrollTo.scrollTo(element, {
                    offset: -30,
                    duration: 300,
                });
            }
        });
    }

    private refresh(type?: AttachmentType): void {
        this.model.getEstimate()
            .then(estimate => {
                this.estimateState = estimate;
                this.enabledAttachments = estimate.enabledAttachmentTypes;
                this.disabledAttachments = this.availableAttachmentTypes.filter(
                    attachmentType => ! this.enabledAttachments.includes(attachmentType),
                );

                if (type !== undefined) {
                    this.scrollToAttachment(type);
                }
            });
    }
}
